import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/discuss.svg';
const Discuss = () => React.createElement(IconSvg, null);
export default Discuss;
